module.exports = __webpack_public_path__ + "static/img/presysv70Two.dbda1a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv70Two.png
// module id = 66x7
// module chunks = 1